export const InactivateBtb = ({ handleClick }) => {
    return (
        <button onClick={handleClick} className="inactivate-btb">
            Inactivate
        </button>
    );
};
